export const ARTIFICIAL_REEFS_SIMPLIFIED_MINZOOM = 9;
export const ARTIFICIAL_REEFS_SIMPLIFIED_CIRCLE_RADIUS = 5;
export const ARTIFICIAL_REEFS_MINZOOM = 12;
export const ARTIFICIAL_REEFS_ICON_SIZE = 0.7;
export const SELECTED_ARTIFICIAL_REEFS_ICON_SIZE = 0.9;
